import { DateTime } from 'luxon';
import { DateRange, LocalTime } from './datePicker/types';

interface QueryWindow {
  fromMs: number,
  toMs: number // exclusivo — ver abajo
}

// Contrato de CX-638 §05/Fase 6 — la única conversión a instantes de todo el
// componente ocurre aquí, en la capa de query:
//
//   cutoff === null
//     ? [ range.start 00:00 , range.end + 1 día 00:00 )   // días completos
//     : [ range.start 00:00 , range.end 00:00 + cutoff )  // último día recortado
//
// Semiabierto en el extremo superior en las dos ramas, para que las
// ventanas compongan sin contar dos veces ninguna fila en un límite —
// toMs es EXCLUSIVO, las queries deben comparar con '<', nunca '<='.
//
// Un día de calendario es la medianoche UTC de esa fecha, el mismo criterio
// con el que la importación guarda las ventas (PX-2291). Así la ventana no
// depende de la zona horaria del navegador.
const utcDay = (date: string): DateTime => DateTime.fromISO(date, { zone: 'utc' });

const resolveQueryWindow = (range: DateRange, cutoff: LocalTime | null): QueryWindow => {
  const fromMs = utcDay(range.start).toMillis();
  if(cutoff === null) {
    const toMs = utcDay(range.end).plus({ days: 1 }).toMillis();
    return { fromMs, toMs };
  }
  const [ hour, minute ] = cutoff.split(':').map(Number);
  const toMs = utcDay(range.end).plus({ hours: hour, minutes: minute }).toMillis();
  return { fromMs, toMs };
};

export { QueryWindow, resolveQueryWindow };
